
export default {
  props: {
    limit: {
      type: [Number, String],
      default: 1,
    },
  },
  data() {
    return {
      showLimitMsg: false,
      associates: [
        {
          firstName: "",
          lastName: "",
          email: null,
          workFunction: null,
        },
      ],
    };
  },
  methods: {
    addNewAssociate() {
      if (this.associates.length < this.limit) {
        if (this.associates.length > 0) {
          if (
            this.associates[this.associates.length - 1].email === null ||
            this.associates[this.associates.length - 1].firstName === "" ||
            this.associates[this.associates.length - 1].lastName === "" ||
            this.associates[this.associates.length - 1].workFunction === null
          ) {
            if (this.$i18n.locale === "hr") {
              this.$toast.error("Niste popupnili sva polja!");
            } else {
              this.$toast.error("You did not filled in all the fields!");
            }
          } else {
            this.associates.push({
              firstName: "",
              lastName: "",
              email: null,
              workFunction: null,
            });
          }
        } else if (this.associates.length === 0) {
          this.associates.push({
            firstName: "",
            lastName: "",
            email: null,
            workFunction: null,
          });
        }
      }
    },
    deleteAssociate(i) {
      this.associates.splice(i, 1);
    },
  },
};
